import { enableProdMode } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { onUserLogout } from './app/Services/datadog-session';
import { AppModule } from './app/app.module';
import { environment } from './app/environments/environment';

export function getBaseUrl() {
  return environment.productionSystemApiBaseUrl;
}

const providers = [{ provide: 'BASE_URL', useFactory: getBaseUrl, deps: [] }];

if (environment.production) {
  enableProdMode();
}

window.onbeforeunload = () => {
  onUserLogout();
};

platformBrowser(providers)
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));
function Constructor() {
  throw new Error('Function not implemented.');
}
